export const PRODUCT_MASTER_PRIVILEGES = {
  insurer: {
    access: [
      "productMaster.insurer.management.view",
      "productMaster.insurer.management.add",
      "productMaster.insurer.management.download",
      "productMaster.insurer.management.bulkUpload",
      "productMaster.insurer.management.viewInactive",
      "productMaster.insurer.management.edit",
      "productMaster.insurer.management.deactivate"
    ],
    view: "productMaster.insurer.management.view",
    add: "productMaster.insurer.management.add",
    download: "productMaster.insurer.management.download",
    bulkUpload: "productMaster.insurer.management.bulkUpload",
    viewInactive: "productMaster.insurer.management.viewInactive",
    edit: "productMaster.insurer.management.edit",
    deactivate: "productMaster.insurer.management.deactivate"
  },
  branch: {
    access: [
      "productMaster.insurerBranch.management.view",
      "productMaster.insurerBranch.management.add",
      "productMaster.insurerBranch.management.edit",
      "productMaster.insurerBranch.management.delete"
    ],
    view: "productMaster.insurerBranch.management.view",
    add: "productMaster.insurerBranch.management.add",
    edit: "productMaster.insurerBranch.management.edit",
    delete: "productMaster.insurerBranch.management.delete"
  },
  policy: {
    access: [
      "productMaster.policy.management.view",
      "productMaster.policy.management.add",
      "productMaster.policy.management.download",
      "productMaster.policy.management.bulkUpload",
      "productMaster.policy.management.viewInactive",
      "productMaster.policy.management.edit",
      "productMaster.policy.management.deactivate"
    ],
    view: "productMaster.policy.management.view",
    add: "productMaster.policy.management.add",
    download: "productMaster.policy.management.download",
    bulkUpload: "productMaster.policy.management.bulkUpload",
    viewInactive: "productMaster.policy.management.viewInactive",
    edit: "productMaster.policy.management.edit",
    deactivate: "productMaster.policy.management.deactivate"
  },
  classOfPolicy: {
    access: [
      "productMaster.classOfPolicy.management.view",
      "productMaster.classOfPolicy.management.add",
      "productMaster.classOfPolicy.management.download",
      "productMaster.classOfPolicy.management.viewInactive",
      "productMaster.classOfPolicy.management.edit",
      "productMaster.classOfPolicy.management.deactivate"
    ],
    view: "productMaster.classOfPolicy.management.view",
    add: "productMaster.classOfPolicy.management.add",
    download: "productMaster.classOfPolicy.management.download",
    viewInactive: "productMaster.classOfPolicy.management.viewInactive",
    edit: "productMaster.classOfPolicy.management.edit",
    deactivate: "productMaster.classOfPolicy.management.deactivate"
  },
  category: {
    access: [
      "productMaster.category.management.view",
      "productMaster.category.management.add",
      "productMaster.category.management.download",
      "productMaster.category.management.viewInactive",
      "productMaster.category.management.edit",
      "productMaster.category.management.deactivate"
    ],
    view: "productMaster.category.management.view",
    add: "productMaster.category.management.add",
    download: "productMaster.category.management.download",
    viewInactive: "productMaster.category.management.viewInactive",
    edit: "productMaster.category.management.edit",
    deactivate: "productMaster.category.management.deactivate"
  }
};

export const productMasterAccessPrivileges = Object.values(PRODUCT_MASTER_PRIVILEGES)
  .flatMap(({ access }) => access);
